/*
 * Copyright (c) Worldline 2023.
 */

export const Errors = {
    invalidOtp: 3,
    invalidAction: 4,
    sendingLimitOtp: 6,
    submissionLimitOtp: 7,
    invalidToken: 8,
    totalSubmissionLimitOtp: 9,
    expiredOtp: 11,
    noOtpInBase: 12,
    evidenceWrongMimeType: 13,
    evidenceIncorrectCroppingData: 14,
    storageError: 19,
    tooBigFile: 23,
    evidenceError: 53,
    cancelReasonNotFound: 55,
    cancelReasonNotValid: 56,
    agreementSSOFailure: 57,
    agreementSSOLimit: 58,
    unexpected: 99
};
